module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/my-time/notifications/notifications.component.scss
// module id = 480
// module chunks = 0